var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categories && _vm.categories.length !== 0)?_c('nav',{staticClass:"categories"},[_c('ul',_vm._l((_vm.categories),function(item){return _c('li',{key:item.id,class:{ current: item.slug === _vm.$route.params.slug }},[_c('Link',{attrs:{"post_link":item.link,"id":`${item.name}-page`},domProps:{"innerHTML":_vm._s(item.name)}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }